import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M8 5v14l11-7L8 5z"
}), 'PlayArrowSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/PlayArrowSharp.js
// module id = 5500
// module chunks = 2